module.exports = __webpack_public_path__ + "img/keyboard-arrow-up-rounded.9db139cd.svg";